/*
 Licensed Materials - Property of IBM
 5737-I23
 Copyright IBM Corp. 2019. All Rights Reserved.
 U.S. Government Users Restricted Rights:
 Use, duplication or disclosure restricted by GSA ADP Schedule
 Contract with IBM Corp.
 */
import React from 'react';

import { Button } from 'carbon-components-react';
import ArrowDown from '@carbon/icons-react/lib/arrow--down/16';
import ArrowUp from '@carbon/icons-react/lib/arrow--up/16';
import Close from '@carbon/icons-react/lib/close/16';


function CustomArrayItem({ key, children, disabled, readonly, index, onReorderClick, onDropIndexClick, hasToolbar, hasMoveDown, hasMoveUp, hasRemove, formContext }) {
    return (
        <div key={key} className="baiw--form-array-item">
            {children}
            {hasToolbar && (
                <div className="baiw--form-array-item__toolbox" >
                    {(hasMoveUp || hasMoveDown) && (
                        <Button
                            renderIcon={ArrowUp}
                            aria-label={formContext ? formContext.moveItemUpLabel : ''}
                            iconDescription={formContext ? formContext.moveItemUpLabel : ''}
                            className="baiw--form-array-item__move-up-button"
                            kind="secondary"
                            disabled={disabled || readonly || !hasMoveUp}
                            onClick={onReorderClick(index, index - 1)}
                        />
                    )}

                    {(hasMoveUp || hasMoveDown) && (
                        <Button
                            renderIcon={ArrowDown}
                            aria-label={formContext ? formContext.moveItemDownLabel : ''}
                            iconDescription={formContext ? formContext.moveItemDownLabel : ''}
                            className="baiw--form-array-item__move-down-button"
                            kind="secondary"
                            disabled={
                                disabled || readonly || !hasMoveDown
                            }
                            onClick={onReorderClick(index, index + 1)}
                        />
                    )}

                    {hasRemove && (
                        <Button
                            renderIcon={Close}
                            aria-label={formContext ? formContext.removeItemLabel : ''}
                            iconDescription={formContext ? formContext.removeItemLabel : ''}
                            className="baiw--form-array-item__remove-button"
                            kind="ghost"
                            disabled={disabled || readonly}
                            onClick={onDropIndexClick(index)}
                        />

                    )}
                </div>
            )}
        </div>
    );
}

export { CustomArrayItem };
